import { useQuery } from "@tanstack/react-query";

import { getPacingMetrics } from "../api/getPacingMetrics";

export const usePacingMetrics = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["pacing-metrics"],
        queryFn: async () => getPacingMetrics(),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
